import { React } from "react";
import emailjs from 'emailjs-com';
import { Form, Input, TextArea, Button } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import styles from "../style";
import { contact, img2 } from "../assets/index"
import "../index.css"
import ReactWhatsapp from "react-whatsapp";
import Footer from "../components/Footer";
import { PiClockBold, PiMapPinFill, } from "react-icons/pi"
import { MdCall, MdEmail } from "react-icons/md";
import transition from "../components/transition";

const SERVICE_ID = "service_17qcucb";
const TEMPLATE_ID = "template_lrg1q3o";
const USER_ID = "XC5doMLIp30a-Nucq";

const Contact = () => {
  const handleOnSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, USER_ID)
      .then((result) => {
        console.log(result.text);
        Swal.fire({
          icon: 'success',
          title: 'Message Sent Successfully'
        })
      }, (error) => {
        console.log(error.text);
        Swal.fire({
          icon: 'error',
          title: 'Ooops, something went wrong',
          text: error.text,
        })
      });
    e.target.reset()
  };
    return (
      <section className={`flex flex-col`}>
          <div className={`${styles.flexCenter} bg-primary flex flex-col`}>
            <div className="relative w-full">
              <div className={`absolute z-10 w-full flex flex-col gap-4 py-40 px-20`}>
                <div className={`${styles.flexStart} flex flex-col `}>
                  <h2 className={`kerning-normal xs:text-lg text-md font-bold text-white`}>
                    What's Next?
                  </h2>
                  <p className={`kerning-normal xs:text-sm text-ss mt-4 max-w-[312px] text-white`}>
                    Looking For An Investment Partner?
                  </p>              
                </div>
                <div className="py-10 flex md:flex-row flex-col justify-center items-start md:gap-40 gap-20">
                  <div className={`${styles.flexStart} flex flex-col gap-4`}>
                    <div className="flex flex-row gap-4 items-start">
                      <PiMapPinFill size={20} color={'white'} />
                      <div className="flex flex-col gap-2">
                        <p className="kerning-normal font-bold xs:text-mm text-sm leading-[27px] text-second">Office Address</p>
                        <p className="kerning-normal font-regular xs:text-sm text-ss leading-[27px] text-white">Westlands, Nairobi Kenya</p>
                      </div>
                    </div>
                    <div className="flex flex-row gap-4 items-start">
                      <MdEmail size={20} color={'white'} />
                      <div className="flex flex-col gap-2">
                        <p className="kerning-normal font-bold xs:text-mm text-sm leading-[27px] text-second">Mail</p>
                        <p className="kerning-normal font-regular xs:text-sm text-ss leading-[27px] text-white">info@afrinextventures.com </p>                 
                      </div>
                    </div>                
                  </div>

                  <div className={`${styles.flexStart} flex flex-col gap-4`}>
                    <div className="flex flex-row gap-4 items-start">
                      <PiClockBold size={20} color={'white'} />
                      <div className="flex flex-col gap-2">
                        <p className="kerning-normal font-bold xs:text-mm text-sm leading-[27px] text-second">Working Hours</p>
                        <p className="kerning-normal font-regular xs:text-sm text-ss leading-[27px] text-white">(Mon-Fri) 8.00AM - 5.00PM</p>
                        <p className="kerning-normal font-regular xs:text-sm text-ss leading-[27px] text-white">(Sat) 8.00AM - 12.00PM</p>
                        <p className="kerning-normal font-regular xs:text-sm text-ss leading-[27px] text-white">Closed on Sun & Holidays  </p>
                      </div>
                    </div>

                    <div className="flex flex-row gap-4 items-start">
                      <MdCall size={20} color={'white'} />
                      <div className="flex flex-col gap-2">
                        <p className="kerning-normal font-poppins font-bold text-[18px] leading-[27px] text-second">Phone</p>
                        <p className="kerning-normal font-poppins font-regular text-[14px] leading-[27px] text-white">+254 793 872 627</p>
                      </div>
                    </div>
                    
                  </div>      
                </div>
              </div>
              <img src={contact} alt="" className="relative w-full h-[840px] md:h-[600px] object-cover" />
            </div>

            <div 
              style={{ 
                backgroundImage: `url(${img2})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                zIndex: 0,
              }}
              className={`w-full ${styles.flexCenter}`}
              >
              <div className={`${styles.flexCenter} flex flex-col py-20 pr-4 max-w-[450px]`}>
                <div className={`${styles.flexStart} flex flex-col gap-4 py-6 `}>
                  <h2 className={`kerning-normal xs:text-md text-mm text-white font-bold`}>
                    Send us an email
                  </h2>
                  <p className={`kerning-normal xs:text-sm text-ss mt-4 max-w-[450px] text-tertiary`}>
                    Drop us an email enquiry and we will respond as soon as possible.
                  </p>              
                </div>
                <Form onSubmit={handleOnSubmit}>
                  <div className="flex sm:flex-row flex-col gap-2 mb-4">
                    <Form.Field
                      id='form-input-control-name'
                      control={Input}
                      name='user_name'           
                      placeholder='Name…'
                      required
                      icon='user circle'
                      iconPosition='left'
                    />
                    <Form.Field
                      id='form-input-control-email'
                      control={Input}
                      name='user_email'          
                      placeholder='Email…'
                      required
                      icon='mail'
                      iconPosition='left'
                    />
                  </div>
                  <div className="flex sm:flex-row flex-col gap-2 mb-4">
                    <Form.Field
                      id='form-input-control-phone'
                      control={Input}
                      name='user_phone'          
                      placeholder='Phone Number'
                      required
                      icon='phone'
                      iconPosition='left'
                    />
                    <Form.Field
                      id='form-input-control-location'
                      control={Input}
                      name='user_location'       
                      placeholder='Location'
                      required
                      icon='pin'
                      iconPosition='left'
                    />
                  </div>
                  <Form.Field
                    id='form-input-control-subject'
                    control={Input}
                    name='user_subject'          
                    placeholder='Subject'
                    required
                    icon='mail'
                    iconPosition='left'
                  />
                  <Form.Field
                    id='form-textarea-control-message'
                    control={TextArea}
                    name='user_message'          
                    placeholder='Your Message…'
                    required
                  />
                  <Button type='submit' color="#7c7401">Send Message</Button>
                </Form>
              </div>
            </div>   
          </div>  

          <Footer />  
      </section>    
    );
};
export default Contact;

/**transition() */